let $seemore = $('.js-seemore-compact'),
	$btn = $seemore.find('.js-seemore-btn'),
	$list = $seemore.find('.js-seemore-list');

function toggleSeemore() {
	$btn.toggleClass('is-active');
	if ($btn.hasClass('is-active')) {
		$list.velocity('slideDown', 200);
	} else {
		$list.velocity('slideUp', 200);
	}
	global.blurOnLeave(this);
}

$btn.on('click', toggleSeemore);



// WEBPACK FOOTER //
// ./temp/components/useful-links/compact/index.js